
{
  "familyId": "GET-BREUK-GEL-MIN",
  "questions": [
    {
      "id": "GET-BREUK-GEL-MIN-001",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{3}{4}$ - $\\frac{1}{4}$ =",
      "context": null,
      "options": ["$\\frac{2}{4}$", "$\\frac{4}{8}$", "$\\frac{2}{8}$", "$\\frac{4}{4}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_quarters",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-min-noemers-optellen", "label": "Noemers ook opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-min-noemers-optellen", "label": "Noemers opgeteld én tellers verwisseld", "optionIndex": 2 },
          { "id": "get.breuk-min-noemers-aftrekken", "label": "Noemers ook afgetrokken", "optionIndex": 2 },
          { "id": "get.breuk-min-tellers-optellen", "label": "Tellers opgeteld i.p.v. afgetrokken", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "fractions": [
              {"numerator": 3, "denominator": 4, "label": "3/4"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 4,
            "label": "3/4 - 1/4 = 2/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij gelijknamige breuken trek je alleen de getallen boven de streep af — het getal onder de streep blijft hetzelfde. Hier: 3 - 1 = 2, en het getal onder de streep blijft 4. Dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$. Vereenvoudigd is dat $\\frac{1}{2}$. Onthoud: bij gelijknamige breuken verandert het getal onder de streep niet!",
        "solutionSteps": [
          "Zijn de getallen onder de streep gelijk? Ja, allebei 4 (gelijknamig)",
          "Trek de getallen boven de streep af: 3 - 1 = 2",
          "Het getal onder de streep blijft hetzelfde: 4",
          "Antwoord: $\\frac{2}{4}$ (= $\\frac{1}{2}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de getallen boven de streep af: 3 - 1 = 2, getal onder blijft 4. Dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$.",
          "1": "Je dacht waarschijnlijk dat je de getallen onder de streep ook moet optellen (4 + 4 = 8). Maar bij gelijknamige breuken blijft het getal onder de streep hetzelfde. Je rekent alleen met de getallen boven de streep: 3 - 1 = 2. Onthoud: het getal onder de streep verandert niet bij gelijknamige breuken.",
          "2": "Je dacht waarschijnlijk dat je zowel boven aftrekt (3 - 1 = 2) als onder optelt (4 + 4 = 8). Maar het getal onder de streep blijft 4, niet 8. Onthoud: bij gelijknamige breuken reken je alleen met de getallen boven de streep.",
          "3": "Je dacht waarschijnlijk dat je de getallen boven de streep moet optellen (3 + 1 = 4) in plaats van aftrekken. Maar het minteken zegt: trek af. 3 - 1 = 2, dus $\\frac{2}{4}$. Onthoud: kijk goed naar het teken (+ of -)."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-002",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{4}{5}$ - $\\frac{2}{5}$ =",
      "context": null,
      "options": ["$\\frac{2}{5}$", "$\\frac{2}{10}$", "$\\frac{6}{5}$", "$\\frac{2}{0}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_fifths",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-min-noemers-optellen", "label": "Noemers ook opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-min-tellers-optellen", "label": "Tellers opgeteld i.p.v. afgetrokken", "optionIndex": 2 },
          { "id": "get.breuk-min-noemers-aftrekken", "label": "Noemers ook afgetrokken (deling door nul)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 4,
            "denominator": 5,
            "fractions": [
              {"numerator": 4, "denominator": 5, "label": "4/5"},
              {"numerator": 2, "denominator": 5, "label": "2/5"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "4/5 - 2/5 = 2/5",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de getallen boven de streep af: 4 - 2 = 2. Het getal onder de streep blijft 5 — dat verandert niet bij gelijknamige breuken. Dus $\\frac{4}{5}$ - $\\frac{2}{5}$ = $\\frac{2}{5}$. Onthoud: bij gelijknamige breuken reken je alleen met de getallen boven de streep, het getal onder verandert niet.",
        "solutionSteps": [
          "Zijn de getallen onder de streep gelijk? Ja, allebei 5 (gelijknamig)",
          "Trek de getallen boven de streep af: 4 - 2 = 2",
          "Het getal onder de streep blijft hetzelfde: 5",
          "Antwoord: $\\frac{2}{5}$"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de getallen boven de streep af: 4 - 2 = 2, getal onder blijft 5. Dus $\\frac{4}{5}$ - $\\frac{2}{5}$ = $\\frac{2}{5}$.",
          "1": "Je dacht waarschijnlijk dat je de getallen onder de streep ook moet optellen (5 + 5 = 10). Maar bij gelijknamige breuken blijft het getal onder hetzelfde: 5. Je rekent alleen met de getallen boven: 4 - 2 = 2. Onthoud: het getal onder verandert niet.",
          "2": "Je dacht waarschijnlijk dat je de getallen boven de streep moet optellen (4 + 2 = 6) in plaats van aftrekken. Maar het minteken zegt: trek af. 4 - 2 = 2, dus $\\frac{2}{5}$. Onthoud: kijk goed naar het teken (+ of -).",
          "3": "Je dacht waarschijnlijk dat je de getallen onder de streep ook moet aftrekken (5 - 5 = 0). Maar dat getal verandert niet bij gelijknamige breuken — het blijft 5. Bovendien kan het getal onder de streep nooit 0 zijn (delen door nul mag niet)."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-003",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{5}{6}$ - $\\frac{3}{6}$ =",
      "context": null,
      "options": ["$\\frac{2}{6}$", "$\\frac{2}{12}$", "$\\frac{8}{6}$", "$\\frac{3}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_sixths",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-min-noemers-optellen", "label": "Noemers ook opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-min-tellers-optellen", "label": "Tellers opgeteld i.p.v. afgetrokken", "optionIndex": 2 },
          { "id": "get.breuk-min-tweede-als-antwoord", "label": "Tweede breuk overgenomen als antwoord", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "fractions": [
              {"numerator": 5, "denominator": 6, "label": "5/6"},
              {"numerator": 3, "denominator": 6, "label": "3/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 6,
            "label": "5/6 - 3/6 = 2/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de getallen boven de streep af: 5 - 3 = 2. Het getal onder blijft 6. Dus $\\frac{5}{6}$ - $\\frac{3}{6}$ = $\\frac{2}{6}$. Vereenvoudigd: $\\frac{2}{6}$ = $\\frac{1}{3}$. Onthoud: bij gelijknamige breuken verandert het getal onder de streep niet.",
        "solutionSteps": [
          "Zijn de getallen onder de streep gelijk? Ja, allebei 6 (gelijknamig)",
          "Trek de getallen boven de streep af: 5 - 3 = 2",
          "Het getal onder blijft hetzelfde: 6",
          "Antwoord: $\\frac{2}{6}$ (= $\\frac{1}{3}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! Trek de getallen boven de streep af: 5 - 3 = 2, getal onder blijft 6. Dus $\\frac{5}{6}$ - $\\frac{3}{6}$ = $\\frac{2}{6}$.",
          "1": "Je dacht waarschijnlijk dat je de getallen onder de streep ook moet optellen (6 + 6 = 12). Maar bij gelijknamige breuken blijft het getal onder hetzelfde: 6. Onthoud: het getal onder de streep verandert niet bij gelijknamige breuken.",
          "2": "Je dacht waarschijnlijk dat je de getallen boven de streep moet optellen (5 + 3 = 8) in plaats van aftrekken. Maar het minteken zegt: trek af. 5 - 3 = 2, dus $\\frac{2}{6}$. Onthoud: kijk goed naar het teken.",
          "3": "Je dacht waarschijnlijk dat het antwoord de tweede breuk is ($\\frac{3}{6}$). Maar je moet de getallen boven aftrekken: 5 - 3 = 2. Het antwoord is $\\frac{2}{6}$, niet $\\frac{3}{6}$. Onthoud: reken altijd uit, neem niet zomaar een getal over."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-004",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Er is $\\frac{7}{8}$ van een taart over. Je eet $\\frac{3}{8}$. Hoeveel taart is er nog over?",
      "context": null,
      "options": ["$\\frac{4}{8}$", "$\\frac{4}{16}$", "$\\frac{10}{8}$", "$\\frac{3}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_context",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-min-noemers-optellen", "label": "Noemers ook opgeteld", "optionIndex": 1 },
          { "id": "get.breuk-min-tellers-optellen", "label": "Tellers opgeteld i.p.v. afgetrokken", "optionIndex": 2 },
          { "id": "get.breuk-min-tweede-als-antwoord", "label": "Tweede breuk overgenomen als antwoord", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 7,
            "denominator": 8,
            "fractions": [
              {"numerator": 7, "denominator": 8, "label": "Over: 7/8"},
              {"numerator": 3, "denominator": 8, "label": "Gegeten: 3/8"}
            ],
            "operator": "-",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 8,
            "label": "7/8 - 3/8 = 4/8 van de taart is nog over",
            "visualType": "circle"
          }
        }
      ],
      "feedback": {
        "explanationText": "Er was $\\frac{7}{8}$ over en je eet $\\frac{3}{8}$. Trek de getallen boven de streep af: 7 - 3 = 4. Het getal onder (8 stukken) blijft hetzelfde. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$ (= $\\frac{1}{2}$, een halve taart). Onthoud: het getal onder de streep vertelt in hoeveel stukken de taart is verdeeld — dat verandert niet.",
        "solutionSteps": [
          "Hoeveel was er? $\\frac{7}{8}$ van de taart",
          "Hoeveel eet je op? $\\frac{3}{8}$ van de taart",
          "Trek de getallen boven de streep af: 7 - 3 = 4",
          "Het getal onder blijft 8 (de taart is in 8 stukken)",
          "Antwoord: $\\frac{4}{8}$ = een halve taart"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 - 3 = 4, getal onder blijft 8. Er is $\\frac{4}{8}$ (= een halve) taart over.",
          "1": "Je dacht waarschijnlijk dat je het getal onder ook moet optellen (8 + 8 = 16). Maar de taart is in 8 stukken verdeeld, niet 16. Bij gelijknamige breuken blijft het getal onder hetzelfde. Onthoud: het getal onder de streep vertelt in hoeveel stukken de taart is verdeeld.",
          "2": "Je dacht waarschijnlijk dat je de getallen boven moet optellen (7 + 3 = 10). Maar je eet stukken op, dus trek af: 7 - 3 = 4. Bovendien kan $\\frac{10}{8}$ niet — je kunt niet meer dan een hele taart overhouden. Onthoud: opeten = aftrekken.",
          "3": "Je dacht waarschijnlijk dat $\\frac{3}{8}$ het antwoord is. Maar $\\frac{3}{8}$ is het deel dat je hebt gegeten, niet wat er over is. Trek af: $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$. Onthoud: lees goed wat de vraag vraagt."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-005",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "fill_in",
      "question": "Een fles is $\\frac{9}{10}$ vol. Je schenkt $\\frac{4}{10}$ uit. Welk deel van de fles is nog vol? Typ je antwoord als breuk (bijv. 3/10).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["5/10", "1/2"],
        "caseSensitive": false,
        "placeholder": "?/?"
      },
      "conceptId": "subtract_like_fractions_fill_context",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 9,
            "denominator": 10,
            "fractions": [
              {"numerator": 9, "denominator": 10, "label": "Vol: 9/10"},
              {"numerator": 4, "denominator": 10, "label": "Uitgeschonken: 4/10"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 10,
            "label": "9/10 - 4/10 = 5/10 = 1/2",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de getallen boven de streep af: 9 - 4 = 5. Het getal onder blijft 10. Dus $\\frac{9}{10}$ - $\\frac{4}{10}$ = $\\frac{5}{10}$. Vereenvoudigd: $\\frac{5}{10}$ = $\\frac{1}{2}$ — de fles is nog half vol.",
        "solutionSteps": [
          "Trek de getallen boven de streep af: 9 - 4 = 5",
          "Het getal onder blijft 10",
          "Antwoord: $\\frac{5}{10}$ (= $\\frac{1}{2}$)"
        ]
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-006",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{7}{12}$ - $\\frac{4}{12}$ =",
      "context": null,
      "options": ["$\\frac{3}{12}$", "$\\frac{3}{24}$", "$\\frac{11}{12}$", "$\\frac{3}{0}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_twelfths",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 7,
            "denominator": 12,
            "fractions": [
              {"numerator": 7, "denominator": 12, "label": "7/12"},
              {"numerator": 4, "denominator": 12, "label": "4/12"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 12,
            "label": "7/12 - 4/12 = 3/12 (= 1/4)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de getallen boven de streep af: 7 - 4 = 3. Het getal onder blijft 12. Dus $\\frac{7}{12}$ - $\\frac{4}{12}$ = $\\frac{3}{12}$. Vereenvoudigd: $\\frac{3}{12}$ = $\\frac{1}{4}$.",
        "solutionSteps": [
          "Zijn de getallen onder de streep gelijk? Ja, allebei 12 (gelijknamig)",
          "Trek de getallen boven af: 7 - 4 = 3",
          "Het getal onder blijft hetzelfde: 12",
          "Antwoord: $\\frac{3}{12}$ (= $\\frac{1}{4}$)"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 - 4 = 3, getal onder blijft 12. Dus $\\frac{3}{12}$.",
          "1": "Je dacht waarschijnlijk dat je het getal onder ook moet optellen (12 + 12 = 24). Maar bij gelijknamige breuken blijft het getal onder hetzelfde: 12. Onthoud: het getal onder verandert niet.",
          "2": "Je dacht waarschijnlijk dat je de getallen boven moet optellen (7 + 4 = 11). Maar het minteken zegt: trek af. 7 - 4 = 3. Onthoud: kijk goed naar het teken (+ of -).",
          "3": "Je dacht waarschijnlijk dat je ook de getallen onder aftrekt (12 - 12 = 0). Maar het getal onder blijft 12. Bovendien kan het nooit 0 zijn."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-007",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{8}{12}$ - $\\frac{2}{12}$ = ... (vereenvoudig je antwoord zo ver mogelijk)",
      "context": null,
      "options": ["$\\frac{1}{2}$", "$\\frac{6}{12}$", "$\\frac{6}{24}$", "$\\frac{10}{12}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_simplify",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-min-niet-vereenvoudigd", "label": "Niet vereenvoudigd", "optionIndex": 1 },
          { "id": "get.breuk-min-noemers-optellen", "label": "Noemers ook opgeteld", "optionIndex": 2 },
          { "id": "get.breuk-min-tellers-optellen", "label": "Tellers opgeteld i.p.v. afgetrokken", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 8,
            "denominator": 12,
            "fractions": [
              {"numerator": 8, "denominator": 12, "label": "8/12"},
              {"numerator": 2, "denominator": 12, "label": "2/12"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "8/12 - 2/12 = 6/12 = 1/2",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: 8 - 2 = 6, het getal onder blijft 12 → $\\frac{6}{12}$. Stap 2: vereenvoudig door beide getallen door 6 te delen: $\\frac{6}{12}$ = $\\frac{1}{2}$.",
        "solutionSteps": [
          "Trek de getallen boven de streep af: 8 - 2 = 6",
          "Het getal onder blijft 12 → $\\frac{6}{12}$",
          "Vereenvoudig: deel beide door 6 → $\\frac{1}{2}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{6}{12}$ vereenvoudigd is $\\frac{1}{2}$.",
          "1": "$\\frac{6}{12}$ is correct uitgerekend, maar de vraag vraagt om te vereenvoudigen. Deel beide getallen door 6: $\\frac{6}{12}$ = $\\frac{1}{2}$.",
          "2": "Je hebt de getallen onder de streep opgeteld (12 + 12 = 24). Maar bij gelijknamige breuken blijft het getal onder hetzelfde: 12. Daarna nog vereenvoudigen tot $\\frac{1}{2}$.",
          "3": "Je hebt de getallen boven de streep opgeteld (8 + 2 = 10). Maar het minteken zegt aftrekken: 8 - 2 = 6. Vereenvoudig dan tot $\\frac{1}{2}$."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-008",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "fill_in",
      "question": "Een pizza is in 8 stukken gesneden. Lisa eet $\\frac{2}{8}$ en Tim eet $\\frac{3}{8}$. Welk deel van de pizza is nog over? Typ je antwoord als breuk (bijv. 3/8).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["3/8"],
        "caseSensitive": false,
        "placeholder": "?/?"
      },
      "conceptId": "subtract_like_fractions_context_two_step",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 8,
            "denominator": 8,
            "fractions": [
              {"numerator": 8, "denominator": 8, "label": "Heel: 8/8"},
              {"numerator": 2, "denominator": 8, "label": "Lisa: 2/8"},
              {"numerator": 3, "denominator": 8, "label": "Tim: 3/8"}
            ],
            "operator": "-",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee keer aftrekken",
            "content": "De hele pizza is $\\frac{8}{8}$. Lisa eet $\\frac{2}{8}$, Tim eet $\\frac{3}{8}$. Trek beide af: $\\frac{8}{8}$ − $\\frac{2}{8}$ − $\\frac{3}{8}$ = $\\frac{8 - 2 - 3}{8}$ = $\\frac{3}{8}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De hele pizza = $\\frac{8}{8}$. Lisa + Tim eten samen $\\frac{2}{8}$ + $\\frac{3}{8}$ = $\\frac{5}{8}$. Wat over is: $\\frac{8}{8}$ − $\\frac{5}{8}$ = $\\frac{3}{8}$.",
        "solutionSteps": [
          "Hele pizza: $\\frac{8}{8}$",
          "Lisa + Tim samen: 2 + 3 = 5 → $\\frac{5}{8}$",
          "Over: 8 - 5 = 3 → $\\frac{3}{8}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-CJ-001",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "comparison_judge",
      "question": "Welke som geeft het kleinste resultaat?",
      "context": null,
      "options": [],
      "correctAnswer": 1,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "$\\frac{6}{10}$ − $\\frac{2}{10}$", "label": "zes tienden min twee tienden" },
            { "id": "b", "content": "$\\frac{5}{10}$ − $\\frac{4}{10}$", "label": "vijf tienden min vier tienden" },
            { "id": "c", "content": "$\\frac{7}{10}$ − $\\frac{3}{10}$", "label": "zeven tienden min drie tienden" }
          ],
          "criterion": "het kleinste resultaat",
          "correctIndex": 1
        }
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 10,
            "fractions": [
              {"numerator": 4, "denominator": 10, "label": "6/10 − 2/10 = 4/10"},
              {"numerator": 1, "denominator": 10, "label": "5/10 − 4/10 = 1/10"},
              {"numerator": 4, "denominator": 10, "label": "7/10 − 3/10 = 4/10"}
            ],
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 10,
            "label": "Kleinste resultaat: 1/10 (optie B)",
            "visualType": "bar"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijknamige breuken aftrekken",
            "content": "Trek alleen de getallen boven de streep af (het getal onder 10 blijft). $\\frac{6}{10}$ − $\\frac{2}{10}$ = $\\frac{4}{10}$. $\\frac{5}{10}$ − $\\frac{4}{10}$ = $\\frac{1}{10}$. $\\frac{7}{10}$ − $\\frac{3}{10}$ = $\\frac{4}{10}$. Het kleinste getal boven wint.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "subtract_like_fractions_compare",
      "variantIndex": 9,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Reken elke som uit: $\\frac{6}{10}$ − $\\frac{2}{10}$ = $\\frac{4}{10}$. $\\frac{5}{10}$ − $\\frac{4}{10}$ = $\\frac{1}{10}$. $\\frac{7}{10}$ − $\\frac{3}{10}$ = $\\frac{4}{10}$. Het kleinste resultaat is $\\frac{1}{10}$ → optie B.",
        "solutionSteps": [
          "Reken alle drie uit (getal onder 10 blijft gelijk)",
          "4/10, 1/10, 4/10",
          "Kleinste = $\\frac{1}{10}$ → optie B"
        ]
      }
    }
  ]
}
